module.exports = {
	/* Grid label */
	application_label: gettext('application'),

	/* Error messages */
	nothing_selected_error_message: gettext('Must select at least one application'),

	/* Actions/buttons in topbar of grid */
	move_stage : gettext('Move Stage'),
	status: gettext('Status'),
	review_status: gettext('Review status'),
	changeStatus: gettext('Change status'),
	labels: gettext('Labels'),
	download: gettext('Download'),
	downloadOptions: gettext('Download Options'),
	singleApplicationsSelected: gettext('Single Applications selected'),
	multipleApplicationsSelected: gettext('Multiple Applications selected'),
	applicationsSelected: gettext('Applications selected:'),
	hide: gettext('Hide from applicant'),
	unhide: gettext('Show to applicant'),
	lock: gettext('Lock'),
	unlock: gettext('Unlock'),
	submit: gettext('Submit'),
	reopen: gettext('Reopen'),
	export: gettext('Export'),
	archive: gettext('Archive'),
	trash: gettext('Move to Trash'),
	revert: gettext('Revert'),
	restore: gettext('Restore'),
	delete_perm: gettext('Delete Permanently'),
	email: gettext('Email'),
	more: gettext('More'),
	create_application: gettext('Create Application'),
	workflow: gettext('Workflow'),
	downloadPDF: gettext('Download (PDF)'),
	exportCSV: gettext('Export (CSV)'),

	/* Award/Decline modal */
	update_apps: gettext('Update Applications'),
	communicate: gettext('Communicate'),
	review_and_award: gettext('Review and Award'),
	award: gettext('Award'),
	save: gettext('Save'),
	decline: gettext('Decline'),
	decision: gettext('Decision'),
	next: gettext('Next'),
	back: gettext('Back'),
	award_apps: gettext('Award Applications'),
	decline_apps: gettext('Decline Applications'),
	award_app: gettext('Award Application'),
	decline_app: gettext('Decline Application'),
	awarded_apps: gettext('Awarded Applications'),
	declined_apps: gettext('Declined Applications'),
	decline_singl: gettext("You've selected one application to decline"),
	decline_mult: gettext("You've selected %s applications to decline"),
	award_singl: gettext("You've selected one application to award!"),
	award_mult: gettext("You've selected %s applications to award!"),
	award_ready: gettext("You're all ready to award!"),
	applicants: gettext('Applicants'),
	award_amount: gettext('Award Amount'),
	no: gettext('No'),
	yes: gettext('Yes'),
	no_status_updates: gettext('(No status updates)'),
	no_stage_updates: gettext('(No stage updates)'),
	no_email: gettext('(No email to send)'),
	render_prev: gettext('Could not render preview'),
	from: gettext('From'),
	subject: gettext('subject'),
	attachments: gettext('Attachments'),
	message: gettext('Message'),
	confirm: gettext('Confirm'),
	award_instructions: gettext('Applicants will be able to see that their applications have been awarded'),
	decline_instructions: gettext('Applicants will be able to see that their applications have been declined'),
	revert_decision: gettext('Revert decision'),
	clear_decision: gettext('Clear decision'),
	awarded_count_sing: gettext('%s Awarded application'),
	awarded_count_mult: gettext('%s Awarded applications'),
	declined_count_sing: gettext('%s Declined application'),
	declined_count_mult: gettext('%s Declined applications'),
	confirm_clear_decision_sing: gettext('Are you sure you want to clear the award decision for the selected application?'),
	confirm_clear_decision_mult: gettext('Are you sure you want to clear the award decisions for the selected applications?'),
	selected_no_decision: gettext('The selected applications do not have a decision'),
	modify_award: gettext('Modify award value'),
	new_award_val: gettext('New award value'),
	edit_custom_field: gettext('Edit custom field'),
	custom_field_updated: gettext('Custom field updated'),

	/* Move to stage modal */
	move_to_stage: gettext('Move to stage'),
	move: gettext('Move'),
	cancel: gettext('Cancel'),
	email_applicant: gettext('Email applicants'),
	set_status: gettext('Set status'),
	reopen_application: gettext('Reopen application'),

	change_status_alert: gettext('Cannot change custom status if applications are in multiple stages'),

	/* Grid titles */
	active: gettext('Active'),
	active_apps: gettext('Active Applications'),
	awarded: gettext('Awarded'),
	awarded_apps: gettext('Awarded Applications'),
	declined: gettext('Declined'),
	declined_apps: gettext('Declined Applications'),
	incomplete: gettext('Incomplete'),
	incomplete_apps: gettext('Incomplete Applications'),
	archived: gettext('Archived'),
	archived_apps: gettext('Archived Applications'),
	trashed: gettext('Trashed'),
	trashed_apps: gettext('Trashed Applications'),
	assigned: gettext('Assigned'),
	assigned_apps: gettext('Assigned Applications'),

	/* Actions */
	delete_applications: gettext('Delete applications?'),
	confirm_delete: gettext('Are you sure you want to delete the selected applications?'),
	permanently_delete_applications: gettext('Permanently delete applications?'),
	confirm_permanently_delete: gettext('Are you sure you want to permanently delete the selected applications?'),
	/* Columns */
	title: gettext('Title'),
	ID: gettext('Application ID'),
	applicant: gettext('Applicant'),
	reviews_completed: gettext('Reviews completed'),
	collaborators: gettext('collaborators'),
	status: gettext('Status'),
	label: gettext('Label'),
	last_submitted: gettext('Last submitted'),
	last_edited: gettext('Last edited'),
	not_submitted: gettext('Not submitted'),
	stage: gettext('Stage'),
	date_created: gettext('Date created'),
	stage_completion: gettext('Stage completion'),
	custom_fields: gettext('Custom fields'),
	review_scores: gettext('Review scores'),
	date_submitted: gettext('Date submitted'),
	not_started: gettext('Not started'),
	profile_image: gettext('Profile image'),
	updated_at: gettext('Updated on'),

	overall_score: gettext('Overall Score'),
	average_score: gettext('Average Score'),
	weighted_score: gettext('Weighted Score'),
	score: gettext('Score'),
	recommendations: gettext('Recommendations Received/Sent'),

	/* Reviews */
	view_review: gettext('View Review ...'),
	view_conflict: gettext('View conflict of interest'),
	conflict_of_interest: gettext('Conflict of Interest'),
	add_conflict_of_interest: gettext('Add conflict of interest'),
	add: gettext('Add'),
	view_conflict: gettext('View conflict of interest'),
	ok: gettext('OK'),

	/* Assignments */
	members: gettext('members'),
	assignments: gettext('Assignments'),
	application: gettext('Application'),
	applications: gettext('Applications'),
	team: gettext('Team'),
	teams: gettext('Teams'),
	completed_on: gettext('Completed on'),
	completed_at: gettext('Completed at'),
	review: gettext('Review'),
	download_review: gettext('Download Review'),
	clear_review: gettext('Clear Review'),
	unassign: gettext('Unassign'),
	not_started: gettext('Not started'),
	in_progress: gettext('In progress'),
	completed: gettext('Completed'),
	all_assignments: gettext('All Assignments'),
	no_team: gettext('No team'),
	currently_assigned_to: gettext('Currently assigned to'),
	no_reviewers_in_stage: gettext('There are no reviewers in this stage'),
	no_teams_in_stage: gettext('There are no teams in this stage'),
	select_at_least: gettext('Please select at least one reviewer or team and one application'),
	assign: gettext('Assign'),
	cannot_unassign_team: gettext('You cannot unassign team assignments individually'),
	and_others: gettext('(%s more)'),
	review_stage: gettext('Review stage'),
	select_review_stage: gettext('Select a review stage'),
	assign_by_selecting: gettext('Assign by selecting'),
	reviewers_and_teams: gettext('Reviewers and Teams'),
	select_reviewers_first: gettext('Select reviewers and teams first'),
	select_applications_first: gettext('Select applications first'),
	select_people: gettext('Select the reviewers & teams to assign applications to:'),
	assigned: gettext('# Assigned'),
	selected: gettext('Selected:'),
	reviewers: gettext('Reviewers'),
	teams: gettext('Teams'),
	name: gettext('Name'),
	view_applicant_profile: gettext('View applicant profile'),
	view_application: gettext('View application'),
	or: gettext('or'),
	unassigned_applications: gettext('unassigned applications'),
	unassigned: gettext('Unassigned'),
	total: gettext('total'),
	currently_assigned: gettext('Currently assigned'),
	completed_percentage: gettext('% Completed'),
	tentative_assignments: gettext('Tentative assignments'),
	reviewer: gettext('Reviewer'),
	reviewer_name: gettext('Name'),
	leave_unassigned: gettext('Leave unassigned'),
	continue_distribution: gettext('Continue distribution even if limits are met'),
	manually_assign: gettext('Manually assign applications'),
	teams_only: gettext('Show review teams only'),
	select_reviewers_and_teams: gettext('Select reviewers & teams to assign applications to'),
	assign_to_selected_applications: gettext('How would you like to assign selected applications (%s) to reviewers?'),
	assign_to_selected_reviewers: gettext('How would you like to assign applications to selected reviewers (%s)?'),
	select_applications: gettext('Select applications to assign'),
	unassign_selected_applications: gettext('Unassign selected applications'),
	unassign_selected_applications_singular: gettext('Unassign selected application'),
	unassign_applications_description: gettext('Yes, I understand that unassigning these applications will permanently delete the review data and that this action cannot be undone.'),
	unassign_applications_description_singular: gettext('Yes, I understand that unassigning this application will permanently delete the review data and that this action cannot be undone.'),
	unassign_applications_message_singular: gettext('Unassigning the application from this reviewer will also delete any associated review data collected from the reviewer.'),
	unassign_applications_message: gettext('Unassigning these applications from this reviewer will also delete any associated review data collected from the reviewer.'),

	unassign_team_warning: gettext('If any of the selected applications are assigned to a review team, the unassign action will not be applied to those applications.'),
	submit_reviews: gettext('Submit reviews'),
	reopen_reviews: gettext('Reopen reviews'),

	clear_selected_reviews_team_description_singular: gettext('Are you sure you want to remove all review data from the selected review team for the selected applications?'),

	clear_selected_reviews_singular: gettext('Clear selected review'),
	clear_selected_reviews: gettext('Clear selected reviews'),

	clear_review_description: gettext('Yes, I understand that these reviews will be permanently deleted and that this action cannot be undone.'),
	clear_review_description_singular: gettext('Yes, I understand that this review will be permanently deleted and that this action cannot be undone.'),

	clear_review_message_singular: gettext('Clearing this reviewer\'s responses will delete all their data collected for this review.'),
	clear_review_message: gettext('Clearing this reviewer\'s responses will delete all their data collected for these reviews.'),

	all_apps_assigned_to_all_reviewers: gettext('All applications are assigned to all selected reviewers'),
	distribute_reviewer_assignments: gettext('Distribute reviewer assignments <strong>randomly</strong>, \
				and <strong>evenly</strong> over selected reviewers'),
	allow_selected_reviewers_previous_stage: gettext('Allow selected reviewers to be assigned \
			applications they reviewed in a previous stage'),
	num_review_assignments_per_app: gettext('Number of review assignments per application'),
	max_number_of_apps_per_reviewer: gettext('Maximum number of applications per reviewer'),
	previous_reviews: gettext('Previous reviews'),


	profile_picture: gettext('Profile picture'),

	/* downloads */
	customizeYourDownload: gettext('Customize your download'),
	downloadSelectedApplicationsAs: gettext('Download selected applications as...'),
	pdfWithAttachments: gettext('Separate PDF for each selected application (with attachments in original format)'),
	pdfPerApplication: gettext('Separate PDF for each selected application'),
	singleFile: gettext('Single PDF of all selected applications'),
	formatFilesAs: gettext('Format files as'),
	pdf: gettext('PDF'),
	originalFormatAsOriginallyUploadedWhereApplicable: gettext('Original format (as originally uploaded, where applicable)'),
	choose_application_tasks: gettext('Choose application tasks'),
	includeInDownloadedFilename: gettext('Include in downloaded file name'),
	applicationId: gettext('Application ID'),
	applicationTitle: gettext('Application Title'),
	applicantName: gettext('Applicant Name'),
	applicationTasksToInclude: gettext('Application tasks to include'),
	allApplicationTasks: gettext('All application tasks'),
	includeEllipses: gettext('Include...'),
	applicationProfiles: gettext('Application Profiles'),
	notes: gettext('Notes'),
	applicationCustomFields: gettext('Application custom fields'),
	applicantCustomFields: gettext('Applicant custom fields'),
	cancel: gettext('Cancel'),
	reviews: gettext('Reviews'),
	select_tasks: gettext('Select tasks'),

	/* awarded applications columns */
	decision_visible: gettext('Decision visible'),
	applicant_decision: gettext('Applicant decision'),
	total_awarded: gettext('Total awarded'),
	amount: gettext('Amount'),
	payments: gettext('Payments'),
	date: gettext('Date'),

	show_decision: gettext('Show decision to applicant'),
	hide_decision: gettext('Hide decision from applicant'),
	edit_award: gettext('Edit award'),

	stage_completion_status: gettext('%(count)s of %(total)s Tasks complete'),
	review_score_status: gettext('%d of %d assignments completed'),
};
